import {FC, useState} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import {OfficeSelector} from 'features/offices/OfficeSelector'
import {FormField, FieldBaseProps} from '../../forms/FormField'
import {Label} from '../../forms/Label'
import {Required} from 'jbc-front/components/presenters/form/Label'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {Note} from 'jbc-front/components/presenters/ui/Note'

type OfficeSelectFieldProps = FieldBaseProps &
  JSX.IntrinsicElements['input'] & {
    name: string
    filterByCurrentOffices: boolean
  }

export const OfficeSelectField: FC<OfficeSelectFieldProps> = ({
  filterByCurrentOffices,
  name,
  label,
  note,
  required = false,
  error = undefined,
}) => {
  const {control} = useFormContext()
  const {field} = useController({
    name,
    control,
  })
  const [selectedOfficeIds, setSelectedOfficeIds] = useState<string[]>([field.value])

  return (
    <FormField>
      {label && (
        <FormField.LabelContainer>
          <Label>
            {label}
            {required && <Required />}
          </Label>
        </FormField.LabelContainer>
      )}

      <OfficeSelector
        filterByCurrentOffices={filterByCurrentOffices}
        selectedIds={selectedOfficeIds}
        onChange={(value) => {
          setSelectedOfficeIds(value)
          field.onChange(value[0])
          field.onBlur()
        }}
      />

      {note && (
        <FormField.NoteContainer>
          <Note>{note}</Note>
        </FormField.NoteContainer>
      )}

      {error && (
        <FormField.ErrorContainer>
          <ErrorMessage>{error}</ErrorMessage>
        </FormField.ErrorContainer>
      )}
    </FormField>
  )
}
